var map = {
	"./en-CA/translation.json": [
		893
	],
	"./en-US/translation.json": [
		892
	],
	"./en-US/translation_old.json": [
		1298,
		3
	],
	"./zh-CN/translation.json": [
		894
	],
	"./zh-CN/translation_old.json": [
		1299,
		4
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1076;
module.exports = webpackAsyncContext;